import React from 'react';

import validate from '@vlabs/shared/validators';
import { Control } from '@vlabs/uikit';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface TelegramNotificationFormProps {
  fieldName?: string;
}

export function TelegramNotificationForm({ fieldName = undefined }: TelegramNotificationFormProps): JSX.Element {
  const { t } = useTranslation();
  const prefix = fieldName ? `${fieldName}.` : '';
  const form = useFormContext();

  return (
    <React.Fragment>
      <Control.Input
        id="chat_id"
        label={t('handlers:policies.storage_policy.callbacks.callback.chat_id.label') as unknown as string}
        placeholder={t('handlers:policies.storage_policy.callbacks.callback.chat_id.placeholder') as unknown as string}
        {...form.register(`${prefix}chat_id`, {
          required: validate.required(),
          validate: validate.integer(),
        })}
        autoFocus
        data-testid="callback.chat_id"
        errors={form.formState.errors}
      />
      <Control.Input
        id="token"
        label={t('handlers:policies.storage_policy.callbacks.callback.token.label') as unknown as string}
        placeholder={t('handlers:policies.storage_policy.callbacks.callback.token.placeholder') as unknown as string}
        {...form.register(`${prefix}token`, {
          required: validate.required(),
        })}
        data-testid="callback.token"
        errors={form.formState.errors}
      />
      <Control.Input
        id="params.timeout"
        label={t('handlers:policies.storage_policy.callbacks.callback.params.timeout.label') as unknown as string}
        placeholder={t('handlers:policies.storage_policy.callbacks.callback.params.timeout.placeholder') as unknown as string}
        {...form.register(`${prefix}params.timeout`, {
          validate: validate.integer(),
        })}
        data-testid="callback.params.timeout"
        errors={form.formState.errors}
      />
    </React.Fragment>
  );
}
